import axios from 'axios'
import {getServerApi} from './config/deployment'

let envUri = getServerApi()
let uploadImageUri = envUri+'/api/listings/maakler/1/uploadImage'

export function compress(source_img_obj, quality, output_format){
        /**
       * Receives an Image Object (can be JPG, PNG, or WEBP) and returns a new Image Object compressed
       * @param {Image} source_img_obj The source Image Object
       * @param {Integer} quality The output quality of Image Object
       * @param {String} output format. Possible values are jpg, png, and webp
       * @return {Image} result_image_obj The compressed Image Object
       */

       var mime_type;
       if(output_format==="png"){
          mime_type = "image/png";
       } else if(output_format==="webp") {
          mime_type = "image/webp";
       } else {
          mime_type = "image/jpeg";
       }

       var cvs = document.createElement('canvas');
       cvs.width = source_img_obj.naturalWidth;
       cvs.height = source_img_obj.naturalHeight;
       var ctx = cvs.getContext("2d").drawImage(source_img_obj, 0, 0);
       var newImageData = cvs.toDataURL(mime_type, quality/100);
       var result_image_obj = new Image();
       result_image_obj.src = newImageData;
       return result_image_obj;
}

export const uploadImages = (images, tempThumbHolders, callbackProgress) =>{
  return new Promise((resolve, reject) =>{
    //sessionStorage.setItem("nrOfImgUploaded", 0)
    const myUploadProgress = (thumbId, holders) => (progress) => {
      let id = thumbId
      let percentage = Math.floor((progress.loaded * 100) / progress.total)
      let callback = callbackProgress
      //if(percentage == 100) percentage = 90
      holders.forEach(function(holder){
        if(holder.id === id) holder.progress = percentage
      });
      callback.call(this, percentage, id)
    }
    var originals = []
    var thumbnails = []
    var uploadedImages = []
    var uploadImageCounter = 0
    for (var i = 0; i < images.length; i++) {

      var config = {
        onUploadProgress: myUploadProgress(tempThumbHolders[i].id, tempThumbHolders)
      };
      var compressedImage = compress(images[i], 85, 'jpeg')
      var blob = convertImageToFile(compressedImage, 'jpeg')
      var formData = new FormData()
      formData.append('img', blob)
      // //formData.append('img', images[i])
      uploadImageActual(formData, config)
        .then(resp => {
          // TODO: Handle single img upload error
          uploadedImages.push({orig:resp.oriUrl, thumb:resp.thumbUrl, aboutImage: resp.aboutImage})
          uploadImageCounter++
          if(images.length === uploadImageCounter){
            resolve(uploadedImages);
          }
        })
    }
  })
}

export const uploadImageActual = (data, config) => {
  return axios.post(uploadImageUri, data, config)
    .then(resp => {
      return resp.data
    })
}

function convertImageToFile(image, mime_type)  {
  var base64data="";
  if(image.src.includes("data:image/jpeg"))base64data = image.src.replace("data:image/jpeg;base64,","");
  else if(image.src.includes("data:image/png")) base64data = image.src.replace("data:image/png;base64,","");

  var bs = atob(base64data);
  var buffer = new ArrayBuffer(bs.length);
  var ba = new Uint8Array(buffer);
  for (var i = 0; i < bs.length; i++) {
      ba[i] = bs.charCodeAt(i);
  }
  return new Blob([ba],{type:"image/"+mime_type});
}

export const uploadProfileImage = (data) => {
  return axios.post(userUri + '/images', data)
    .then(resp => {
      return resp.data
    })
    .catch(err => {
    })
}

// NOT IN USE
// Doesnt work with Files
export const uploadImageNotInUse = (compressed_img_obj, upload_url, file_input_name, filename, successCallback, errorCallback, duringCallback, customHeaders) =>{
  return new Promise((resolve, reject) =>{
      //ADD sendAsBinary compatibilty to older browsers
     if (XMLHttpRequest.prototype.sendAsBinary === undefined) {
         XMLHttpRequest.prototype.sendAsBinary = function(string) {
             var bytes = Array.prototype.map.call(string, function(c) {
                 return c.charCodeAt(0) & 0xff;
             });
             this.send(new Uint8Array(bytes).buffer);
         };
     }

     var type;
     if(filename.substr(-4).toLowerCase()===".png"){
         type = "image/png";
     } else if(filename.substr(-5).toLowerCase()===".webp") {
         type = "image/webp";
     } else {
         type = "image/jpeg";
     }

     var data = compressed_img_obj.src;
     data = data.replace('data:' + type + ';base64,', '');

     var xhr = new XMLHttpRequest();
     xhr.open('POST', upload_url, true);
     var boundary = 'someboundary';

     xhr.setRequestHeader('Content-Type', 'multipart/form-data; boundary=' + boundary);

     // Set custom request headers if customHeaders parameter is provided
     if (customHeaders && typeof customHeaders === "object") {
       for (var headerKey in customHeaders){
         xhr.setRequestHeader(headerKey, customHeaders[headerKey]);
       }
     }

     // If a duringCallback function is set as a parameter, call that to notify about the upload progress
     if (duringCallback && duringCallback instanceof Function) {
       xhr.upload.onprogress = function (evt) {
         if (evt.lengthComputable) {
           duringCallback ((evt.loaded / evt.total)*100);
         }
       };
     }

     xhr.sendAsBinary(['--' + boundary, 'Content-Disposition: form-data; name="' + file_input_name + '"; filename="' + filename + '"', 'Content-Type: ' + type, '', atob(data), '--' + boundary + '--'].join('\r\n'));

     xhr.onreadystatechange = function() {
       if (this.readyState == 4){
         if (this.status == 200) {
           //successCallback(this.responseText);
           resolve(this.responseText)
         }else if (this.status >= 400) {
           if (errorCallback &&  errorCallback instanceof Function) {
             //errorCallback(this.responseText);
             reject(this.responseText)
           }
         }
       }
     };
  })
}



// WEBPACK FOOTER //
// ./src/imageFunctions.js